import React from 'react'
import { TextInput } from 'react-admin'
import { WithGetSource } from 'types/common'
import KToolTip from 'ui-shared/KTooltip'

type RatioMultiplierProps = Partial<WithGetSource<'quantityMultiplier'>>

export const getRatioMultiplier = (e: number) => 100 / e

const RatioMultiplier: React.FC<RatioMultiplierProps> = ({ getSource }) => (
  <KToolTip title={'tooltip.hint.ratioMultiplier'}>
    <TextInput
      label="form.fields.ratioMultiplier"
      source={getSource!('quantityMultiplier')}
      type="number"
      defaultValue={1}
      parse={(e: number) => getRatioMultiplier(e)}
      format={(e: number) => getRatioMultiplier(e)}
    />
  </KToolTip>
)

export default RatioMultiplier
